if (!customElements.get('back-in-stock')) {
    customElements.define(
        'back-in-stock',
        class BackInStock extends HTMLElement {
            constructor() {
                super();
                this.renderComponent();
                this.companyId = "WNF3cp";
            }

            static get observedAttributes() {
                return ['should_render', 'product_name', 'variant_title', 'variant_id'];
            }

            attributeChangedCallback() {
                this.renderComponent();
            }

            get shouldRender() {
                return this.getAttribute('should_render') === 'true';
            }

            get productTitle() {
                return this.getAttribute('product_Title') || 'Product';
            }

            get variantTitle() {
                return this.getAttribute('variant_title') || 'Variant';
            }
            get variantId() {
                return this.getAttribute('variant_id') || '';
            }

            renderComponent() {
                if (!this.shouldRender) {
                    this.innerHTML = ''; // Clear content if should_render is false

                    return;
                }

                this.innerHTML = `
                    <div class="back-in-stock-popup-overlay">
                        <div class="back-in-stock-popup">
                            <button class="close-btn">&times;</button>
                            <h4 class="back-in-stock-heading">${this.productTitle}</h4>
                            <h5 class="back-in-stock-variant-heading">${this.variantTitle}</h5>
                            <p class="back-in-stock-text">We will send you a notification as soon as this product is available again.</p>
                            <form class="back-in-stock-form">
                                <input type="email" name="email" placeholder="Enter your email" required>
                                <input type="hidden" name="variant_id" value="${this.variantId}">
                                <button class="back-in-stock-submit" type="submit">Notify me when available</button>
                                <p class="back-in-stock-success-msg" style="display:none;">You're in! We'll let you know when it's back.</p>
                            </form>
                        </div>
                    </div>
                    <button class="trigger-back-in-stock-btn">Notify me when available</button>
                `;

                // Cache DOM elements
                this.overlay = this.querySelector('.back-in-stock-popup-overlay');
                this.closeButton = this.querySelector('.close-btn');
                this.openButton = this.querySelector('.trigger-back-in-stock-btn');
                this.form = this.querySelector('.back-in-stock-form');
                this.emailInput = this.form.querySelector('input[name="email"]');
                this.variantInput = this.form.querySelector('input[name="variant_id"]');
                this.successMessage = this.querySelector('.back-in-stock-success-msg');
                
                // Add event listeners
                this.attachEventListeners();
            }

            attachEventListeners() {
                if (!this.shouldRender) return;

                this.openButton.addEventListener('click', this.openPopup.bind(this));
                this.closeButton.addEventListener('click', this.closePopup.bind(this));
                this.form.addEventListener('submit', this.handleSubmit.bind(this));
            }

            openPopup() {
                if (!this.shouldRender) return;
                this.overlay.classList.add('active');
            }

            closePopup() {
                if (!this.shouldRender) return;
                this.overlay.classList.remove('active');
            }

            handleSubmit(event) {
                if (!this.shouldRender) return;
                event.preventDefault();
                const email = this.emailInput.value.trim();
                const variantId = this.variantInput.value.trim();
                if (!email || !variantId) {
                    alert('Please enter a valid email and select a variant.');
                    return;
                }
                const payload = {
                    "data": {
                      "type": "back-in-stock-subscription",
                      "attributes": {
                        "profile": {
                          "data": {
                              "type": "profile",
                              "attributes": {
                                  "email": email,
                              }
                          }
                        },
                        "channels": ["EMAIL"],
                      },
                      "relationships": {
                        "variant": {
                          "data": {
                            "type": "catalog-variant",
                            "id": `$shopify:::$default:::${variantId}`
                          }
                        }
                      }
                    }
                  }
                  var requestOptions = {
                    method: 'POST',
                    headers: {
                      "Content-Type": "application/json",
                      "revision":"2024-06-15"
                    },
                    body: JSON.stringify(payload),
                };
              fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.companyId}`, requestOptions)
              .then(result => {
  
                  // Check for 202 Accepted
                  if (result.status === 202) {

                      // Show success message
                      this.form.reset(); // Reset the form
                      this.successMessage.style.display = 'block';
  
                      // Hide popup after 2 seconds
                      setTimeout(() => {
                          this.successMessage.style.display = 'none';
                          this.overlay.classList.remove('active');
                      }, 2000);
                  } else {
                      alert("Something went wrong. Please try again Later.",result);
                  }
              })
              .catch(error => {
                  alert("Something went wrong. Please try again Later.",error);
              });
            }
        }
    );
}
